export default __webpack_public_path__ + "static/media/empty-card.166e6eae.svg";